// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3bLHu","col":"CardReaderDesc_col__1FVD3","label":"CardReaderDesc_label__3pxO5"};